<div class="avi-health-score-footer">
    <cds-button
        action="flat"
        class="avi-health-score-footer__view-health"
        (click)="handleViewHealthClick()"
    >
        {{ l10nKeys.viewHealthLabel | vtranslate }}
    </cds-button>
</div>
